var _templateObject;

function _taggedTemplateLiteral(strings, raw) { if (!raw) { raw = strings.slice(0); } return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

import styled from 'styled-components';
import forSize from '../../mediaQueries';
/**
 * A js file containing exports that relate to
 * the functionality and styles of the Button component.
 * The component uses styled-components to render.
 * @object
 * @param {object} props - React props.
 * @returns {JSX.Element} - Rendered component (define any specifics if applicable)
 */

export var sizes = {
  skinny: '32px',
  small: '40px',
  medium: '60px'
};
export var alignOptions = {
  alignLeft: 'flex-start',
  alignCenter: 'center',
  alignRight: 'flex-end'
};
export var ButtonBase = styled.button(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  vertical-align: middle;\n  touch-action: manipulation;\n  cursor: pointer;\n  background-image: none;\n  white-space: nowrap;\n  user-select: none;\n  overflow: visible;\n  text-transform: none;\n  display: flex;\n  align-items: center;\n  width: 100%;\n  font-family: inherit;\n  padding-right: 19px;\n  padding-left: 19px;\n  text-align: center;\n  font-size: 16px;\n  font-weight: 600;\n  line-height: 20px;\n  border-radius: 4px;\n\n  justify-content: ", ";\n  height: ", ";\n\n  color: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n\n  &:hover {\n    background-color: ", ";\n    border: 1px solid ", ";\n  }\n\n  @media ", " {\n    display: inline-flex;\n  }\n\n  &:focus {\n    outline: 0;\n  }\n\n  &:disabled {\n    opacity: 50%;\n  }\n"])), function (props) {
  return props.alignContent;
}, function (props) {
  return props.height;
}, function (props) {
  return props.color;
}, function (props) {
  return props.bgColor;
}, function (props) {
  return props.color;
}, function (props) {
  return props.bgColorHover;
}, function (props) {
  return props.borderHover;
}, forSize.medium);